var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowFloating)?_c('div',{staticClass:"league-floating"},[_c('img',{attrs:{"src":require("@/assets/images/league-floating.png")},on:{"click":_vm.moveWriterInfo}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }